
 <template>
  <v-container fluid="fluid" class="text-xs-center mpa-0">
    <v-layout row wrap>
      <v-data-table :headers="headers" :items="items" class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.subject }}</td>
          <td class="text-xs-right">{{ props.item.sentDateTime }}</td>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
import * as utils from "@/utils/utils";

export default {
  name: "messages",
  props: [],
  mounted() {
    this.getMessages();
  },
  data() {
    return {
      headers: [
        {
          text: "Onderwerp",
          align: "left",
          sortable: false,
          value: "subject"
        },
        { text: "Datum", value: "sentDateTime" }
      ],
      items: []
    };
  },
  methods: {
    getMessages() {
      let self = this;
      utils
        .getData(basePath + "api/messages/getMessages")
        .then(function(response) {
          self.items = response.data;
        });
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.messages {
}
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue